import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { initPostHog } from './lib/posthog';
import { install as installConsoleErrorBuffer } from './lib/consoleErrorBuffer';
import App from './App';

initPostHog();
installConsoleErrorBuffer();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
